import React from "react";

export const AuthFlowChanged = React.createContext(null);
